import { UKSortCodeBankForm } from '../AddPayoutAccountUKSortCodeForm/AddPayoutAccountUKSortCodeFormProps.types';
import { IBANForm } from '../AddPayoutAccountIBANForm/AddPayoutAccountIBANForm.types';
import { FORM_ID } from '../../utils/validate';

export type AddPayoutAccountUKBankFormsProps = {
  handleFormComplete: (ready: boolean) => void;
  handleFormChange: ({
    id,
    form,
  }: {
    id: FORM_ID;
    form: IBANForm | UKSortCodeBankForm;
  }) => void;
};

export enum BankAccountType {
  LOCAL = 'Local',
  IBAN = 'Iban',
}
